/*
 * Custom countdown timer (shared by DOD + BYOC sections).
 *
 * Target is resolved per-timer:
 *   - data-deadline="<ISO datetime>"  → counts down to that fixed instant,
 *     then holds at 00:00:00 (campaign deadline, set via section props).
 *   - no data-deadline                → counts down to the next local midnight
 *     and auto-restarts each day (the "deal of the day" daily reset).
 */
(function () {
  'use strict';

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  document.querySelectorAll('[data-dod-timer]').forEach(function (root) {
    var hEl = root.querySelector('[data-h]');
    var mEl = root.querySelector('[data-m]');
    var sEl = root.querySelector('[data-s]');
    if (!hEl || !mEl || !sEl) { return; }

    // Fixed deadline from props, if provided and parseable; else daily midnight.
    var deadline = null;
    if (root.dataset.deadline) {
      var parsed = new Date(root.dataset.deadline);
      if (!isNaN(parsed.getTime())) { deadline = parsed; }
    }

    function tick() {
      var now = new Date();
      var target;
      if (deadline) {
        target = deadline;
      } else {
        target = new Date();
        target.setHours(24, 0, 0, 0); // next local midnight
      }
      var diff = Math.max(0, target.getTime() - now.getTime());
      var totalSec = Math.floor(diff / 1000);
      var h = Math.floor(totalSec / 3600);
      var m = Math.floor((totalSec % 3600) / 60);
      var s = totalSec % 60;
      hEl.textContent = pad(h);
      mEl.textContent = pad(m);
      sEl.textContent = pad(s);
    }

    tick();
    setInterval(tick, 1000);
  });
})();
